import { createApp, getCurrentInstance } from 'vue';
import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';
import Toast from 'vue-toastification';
import { RouterLink } from 'vue-router';

import ODS from '@/ods/index.ts';

import 'vue-toastification/dist/index.css';

import 'omind-design-system/assets/styles/all.scss';
import './assets/styles/style.css';
import './assets/styles/ods-style.scss';
import './assets/styles/widgets.scss';
import { isInDevelopmentMode, isInLocalDevelopmentMode } from '@/functions/development';
import axios from 'axios';

if (isInLocalDevelopmentMode()) {
  axios.defaults.headers.common['Origin'] = 'https://sta-hub.omind.me';
}

const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__fade',
  maxToasts: 20,
  newestOnTop: true,
};

const app = createApp(App);

if (import.meta.env.VITE_ICONS_URL) {
  app.provide('odsIconPath', import.meta.env.VITE_ICONS_URL);
}
app.provide('RouterLinkComponent', RouterLink);
app.mixin({
  created() {},
  mounted() {
    if (isInDevelopmentMode()) {
      const component = getCurrentInstance();
      const componentName = component?.type.__name;

      if (componentName) {
        const regex = /\d+(?:_\d+)+\b|_\d+(?:_\d+)+/g;
        const matches = componentName.match(regex);
        if (matches) {
          const version = matches[0].slice(1);
          //@ts-ignore
          const el = component.ctx.$el;
          
          //el.style.border = 'dashed 2px #FF0000'

          if (app._container) {
            setTimeout(() => {
              const bounding = el.getBoundingClientRect();

              const labelContainer = document.getElementById('version-label-container')!;
              const border = labelContainer.appendChild(document.createElement('div'));
              border.classList.add('version-border');
              border.style.top = bounding.top + 'px';
              border.style.left = bounding.left + 'px';
              border.style.width = bounding.width + 'px';
              border.style.height = bounding.height + 'px';

              const label = labelContainer.appendChild(document.createElement('div'));
              label.classList.add('version-label');
              //label.innerHTML = version
              label.innerHTML = componentName;
              label.style.top = bounding.top + 'px';
              label.style.right = window.innerWidth - (bounding.left + bounding.width) + 'px';
            }, 1000);
          }
        }
      }
    }
  },
  updated() {},
  unmounted() {},
});
app.use(router);
app.use(i18n);
app.use(Toast, toastOptions);
//@ts-ignore
app.use(ODS);
//app.use(useODSPlugin);

app.mount('#app');
